"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestFactory = void 0;
const requestFactory = (type) => (payload, meta) => ({
    type,
    payload,
    meta,
});
exports.requestFactory = requestFactory;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVxdWVzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9mYWN0b3J5L3JlcXVlc3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBR08sTUFBTSxjQUFjLEdBQUcsQ0FBb0IsSUFBWSxFQUFFLEVBQUUsQ0FBQyxDQUNqRSxPQUF3QixFQUN4QixJQUFVLEVBQ2dCLEVBQUUsQ0FBQyxDQUFDO0lBQzlCLElBQUk7SUFDSixPQUFPO0lBQ1AsSUFBSTtDQUNMLENBQUMsQ0FBQTtBQVBXLFFBQUEsY0FBYyxrQkFPekIifQ==